import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { signTextClass } from "@/lib/tone";

import type { TtuStep } from "../api";
import { DATA_FRESH_MAX_DAYS, daysSince, formatShortDate, formatTtuPct, formatTtuValue } from "../format";

export function FlowCard({ label, step, mover = false, onOpen }: {
  label: string; step: TtuStep; mover?: boolean; onOpen?: () => void;
}) {
  const lagging = (daysSince(step.data_through) ?? 0) > DATA_FRESH_MAX_DAYS;
  const body = <Card className={cn("h-full", mover && "border-2 border-ks-purple ring-0") }>
    <CardContent className="flex h-full flex-col gap-3">
      <div className="flex items-center justify-between gap-2"><h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</h2>{lagging && <Badge variant="outline">Lagging</Badge>}</div>
      {!step.measured ? <p className="text-sm text-muted-foreground">Not measured for this channel. Shopify MENA has no storefront traffic source.</p> : <>
        <p className="text-3xl font-semibold tabular-nums text-ks-ink">{formatTtuValue(step.value, step.unit)}</p>
        <p className="text-xs text-muted-foreground">{step.unit === "%" ? "orders ÷ sessions" : step.unit}</p>
        <p className="flex flex-wrap gap-x-3 text-sm text-ks-ink">
          <span>YoY <span className={signTextClass(step.yoy_pct ?? null)}>{formatTtuPct(step.yoy_pct ?? null)}</span></span>
          <span>WoW <span className={signTextClass(step.wow_pct ?? null)}>{formatTtuPct(step.wow_pct ?? null)}</span></span>
          <span>MoM <span className={signTextClass(step.mom_pct ?? null)}>{formatTtuPct(step.mom_pct ?? null)}</span></span>
        </p>
        <p className="text-xs text-muted-foreground">data to {formatShortDate(step.data_through)}</p>
      </>}
      {onOpen && <p className="mt-auto text-sm font-medium text-ks-purple">Open breakout ›</p>}
    </CardContent>
  </Card>;
  if (!onOpen) return body;
  const accessible = step.measured
    ? `${label} ${formatTtuValue(step.value, step.unit)}${step.unit === "%" ? "" : ` ${step.unit}`} ${movementWords(step.yoy_pct ?? null)} on last year. Open breakout`
    : `${label}. Not measured for this channel. Open breakout`;
  return <button type="button" data-nonmutating onClick={onOpen} aria-label={accessible} className="text-left">{body}</button>;
}

const movementWords = (value: number | null) => value == null ? "with no comparison" : `${value < 0 ? "down" : "up"} ${Math.abs(value)}%`;
